import axios from "axios";
import { getCookie } from "../utils/utils";

axios.defaults.baseURL = "/api";
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
axios.defaults.withCredentials = true;

const axiosReq = axios.create();
const axiosRes = axios.create();

// Add CSRF token to request headers
axiosReq.interceptors.request.use(
    (config) => {
        const csrfToken = getCookie('csrftoken');
        if (csrfToken) {
            config.headers['X-CSRFToken'] = csrfToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosReq.defaults.timeout = 120000; // 2 minutes instead of 30s

axiosReq.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
            error.timeout = true;
        }
        return Promise.reject(error);
    }
);

export { axiosReq, axiosRes };
